export default {
  bind(el, { value }) {
    el.setAttribute('data-e2e', value)
  },
  componentUpdated(el, { value }) {
    el.setAttribute('data-e2e', value)
  }
}
